import styled from 'styled-components';
import React, { useEffect, useRef, useState } from 'react';

/* JS */
import * as Server from '../../assets/js/Server.js';

/* DatePicker */
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

/* PDF */
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import ReportAnalysis from './report/analysis';
import ReportDetailReport from './report/detail';
import ReportCover from './report/cover';
import Loading from '../../components/util/Loading';

export default function CustomerReport() {
  const printRef = useRef(null);

  const today = new Date();

  const [startDate, setStartDate] = useState(today);
  const [isLoading, setIsLoading] = useState(false);
  const [clientList, setClientList] = useState();
  const [captureList, setCaptureList] = useState();
  const [search, setSearch] = useState({
    custMstSeq: '',
    custName: '',
    startDate: startDate.toISOString().substring(0, 10),
    dateType: 'W'
  });

  useEffect(() => {
    getClientList();
    getClientCaptureList();
  }, []);

  //고객사 조회
  const getClientList = () => {
    Server.sendGet('client/select', {}, getClientListCallback).then();
  };

  const getClientListCallback = res => {
    setClientList(res['resultList']);
  };

  //레포트 데이터 조회
  const getClientCaptureList = () => {
    Server.sendGet('client/capture', search, getClientCaptureListCallback).then();
  };

  const getClientCaptureListCallback = res => {
    setCaptureList(res['resultObject']);
  };

  const changeStartDate = date => {
    setStartDate(date);
    setSearch(() => {
      return {
        ...search,
        startDate: search.dateType === 'W' ? date.toISOString().substring(0, 10) : date.toISOString().substring(0, 7),
      }
    })
  };

  const changeDateType = value => {
    setStartDate(today);
    setSearch(() => {
      return {
        ...search,
        dateType: value,
        startDate: value === 'W' ? today.toISOString().substring(0, 10) : today.toISOString().substring(0, 7),
      };
    });
  };

  const searchData = () => {
    getClientCaptureList();
  };

  const handlePDF = async () => {
    setIsLoading(true);

    const element = printRef.current;

    if (!element) {
      return;
    }

    const pages = element.querySelectorAll('.page'); // 각 .page 요소 선택
    const pdf = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'a4'
    });

    pdf.setProperties({
      title: search.custName + ' Report ' + today.toISOString().substring(0, 10)
    });

    for (let i = 0; i < pages.length; i++) {
      const pageElement = pages[i];

      // textarea, input, select를 span으로 교체
      const textAreas = pageElement.querySelectorAll('textarea');
      const inputs = pageElement.querySelectorAll('input');
      const selects = pageElement.querySelectorAll('select');

      const spans = [];

      // textarea를 span으로 교체
      textAreas.forEach(textarea => {
        const span = document.createElement('span');
        span.textContent = textarea.value;
        textarea.parentNode.replaceChild(span, textarea);
        spans.push({ element: textarea, span });
      });

      // input을 span으로 교체
      inputs.forEach(input => {
        const span = document.createElement('span');
        span.textContent = input.value;
        input.parentNode.replaceChild(span, input);
        spans.push({ element: input, span });
      });

      // select를 span으로 교체 (선택된 옵션 값 사용)
      selects.forEach(select => {
        const span = document.createElement('span');
        span.textContent = select.options[select.selectedIndex]?.text || '';
        select.parentNode.replaceChild(span, select);
        spans.push({ element: select, span });
      });

      // html2canvas로 각 페이지 캡처
      const canvas = await html2canvas(pageElement, {
        scale: 1.5,
        useCORS: true,
        logging: false,
        allowTaint: false,
        windowWidth: pageElement.scrollWidth,
        windowHeight: pageElement.scrollHeight
      });

      // span을 다시 원래 요소(textarea, input, select)로 교체
      spans.forEach(({ element, span }) => {
        span.parentNode.replaceChild(element, span);
      });

      const imgData = canvas.toDataURL('image/png');
      // A4 크기 설정
      const a4Width = 210; // A4 width in mm
      const imgWidth = a4Width;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // 페이지별로 추가
      if (i > 0) {
        pdf.addPage();
      }

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    }

    // PDF 새 창에서 열기
    const pdfOutput = pdf.output('bloburl');

    window.open(pdfOutput);

    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <Loading/>}

      {/* 셀렉트 박스 모달 <ReportCheckModal /> */}
      <ReportWrap>
        <div className='content-inner'>
          <div className='title'>
            <div className='title-head'>
              <i/>
              <h4>Customer Report</h4>
            </div>
          </div>
          <div className='search-area space'>
            <div className='search-menu'>
              <CateIn>
                <Cate>
                  <CateSel
                    name='clientForm'
                    id='clientForm'
                    value={search?.custMstSeq}
                    onChange={e => {
                      setSearch(item => {
                        return {
                          ...item,
                          custMstSeq: e.target.value,
                          custName: e.target.options[e.target.selectedIndex].text,
                        };
                      });
                    }}
                  >
                    <option value={''}>Client</option>
                    {clientList?.map(item => (
                      <option key={item.custMstSeq} value={item.custMstSeq}>{item.custName}</option>
                    ))}
                  </CateSel>
                </Cate>
              </CateIn>
              <CateIn>
                <Cate>
                  <CateSel
                    name='dateForm'
                    id='dateForm'
                    value={search?.dateType}
                    onChange={e => {
                      changeDateType(e.target.value)
                    }}
                  >
                    <option value={'W'}>Weekly</option>
                    <option value={'M'}>Monthly</option>
                  </CateSel>
                </Cate>
              </CateIn>
              <div className='date-box'>
                {search.dateType === 'W' &&
                  <DatePicker selected={startDate} dateFormat='yyyy/MM/dd' onChange={(date) => changeStartDate(date)}/>
                }
                {search.dateType === 'M' &&
                  <DatePicker
                    selected={startDate}
                    dateFormat='yyyy-MM'
                    onChange={(date) => changeStartDate(date)}
                    showMonthYearPicker
                  />
                }
                <button
                  className='search-btn'
                  onClick={searchData}
                >Search</button>
              </div>
            </div>

            <BtnDesc>
              <TitBtn onClick={handlePDF}>
                <span>Check</span>
              </TitBtn>
              <TitBtn onClick={handlePDF}>
                <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg'/>
                <span>PDF</span>
              </TitBtn>
            </BtnDesc>
          </div>
          {/* PDF 커버 */}
          <div className='content'>
            <div ref={printRef}>
              <ReportCover clientName={search.custName} targetDate={search.startDate}/>
              {/*<ReportOverview />*/}
              <ReportAnalysis captureList={captureList}/>
              <ReportDetailReport detailList={captureList?.detailDataList}/>
            </div>
          </div>
        </div>
      </ReportWrap>
    </>
  )
}

const BtnDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

const Ic = styled.img.attrs({ alt: 'Util Icon' })``;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateSel = styled.select`
  width: 200px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const ReportWrap = styled.div`
  position: relative;
  flex: 1;
  background: #ffffff;

  .react-datepicker__tab-loop {
    position: absolute;
  }

  // 페이지 Styled
  .page {
    height: 2206px;

    &:not(.cover) {
      padding: 30px 20px;
    }

    .page-head {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-bottom: 10px;
      border-bottom: 2px solid #0072B9;

      h4 {
        font-weight: 600;
        font-size: 24px;
        color: #000000;
      }

      p {
        font-size: 14px;
        font-weight: 400;
        color: #0072B9;
      }
    }

    .page-content {
      position: relative;

      section {
        margin-top: 60px;
        padding: 0 60px;

        .sec-tit {
          position: relative;
          display: flex;
          align-items: center;
          gap: 0 10px;

          i {
            display: block;
            width: 8px;
            height: 8px;
            background: transparent;
            border: 1px solid #000000;
          }

          strong {
            font-weight: 600;
            font-size: 18px;
            color: #000000;
          }
        }

        .sec-content {
          margin-top: 30px;

          canvas {
            height: 550px !important;
          }

        }
      }
    }

    table {
      position: relative;
      border: 1px solid #0072B9;

      // 기본 테이블 세팅    
      &.side-border {
        border-left: none;
        border-right: none;

        td {
          padding: 10px;
        }
      }

      thead th {
        border-bottom: 1px solid #0072B9;

        + th {
          border-left: 1px solid #0072B9;
        }
      }

      .pest-group + .pest-group {
        border-top: 1px solid #0072B9;
      }

      .pest-group:nth-child(even) {
        background: #f7f7f7;

        input, select, textarea {
          background-color: #ffffff;
        }
      }

      tbody td + td, tbody th + td, .rowSpan td {
        border-left: 1px solid #0072B9;
      }

      tbody tr + tr td, tbody tr + tr th {
        border-top: 1px solid #0072B9;
      }

      th {
        text-align: center;
        font-weight: 400;
        font-size: 20px;
        line-height: 1.2;
        color: #000000;
        vertical-align: middle;

        &.p20 {
          padding: 20px 0;
        }

        &.bold {
          font-weight: 600;
        }
      }

      td {
        text-align: center;
        font-weight: 400;
        font-size: 20px;
        line-height: 1.2;
        color: #000000;
        vertical-align: middle;

        &.bold {
          font-weight: 600;
        }

        &.left {
          text-align: left;
        }
      }

      span {
        text-align: left;
        font-size: 20px;
        line-height: 1.5;
        font-weight: 400;
      }

      input, select {
        width: 90%;
        padding: 10px;
        border: 1px solid #d4d4d4;
        outline: none;
        resize: none;
        font-size: 18px;
        line-height: 1.5;
        font-weight: 400;
        color: #000000;
        text-align: center;
        background: #f7f7f7;
        cursor: pointer;
      }

      select {
        cursor: pointer;
      }

      textarea {
        width: 100%;
        padding: 10px;
        border: none;
        outline: none;
        resize: none;
        font-size: 20px;
        line-height: 1.5;
        font-weight: 400;
        color: #000000;
        text-align: center;
        vertical-align: middle;

        &.left {
          text-align: left;
        }
      }


      //상세 리포트 테이블
      &.detail-report {
        th {
          padding: 10px 0;
        }

        td {
          padding: 10px 0;
        }
      }
    }
  }

  .cover {
    position: relative;

    .cover-head {
      z-index: 2;
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      text-align: center;
    }

    .cover-content {
      z-index: 3;
      position: absolute;
      top: 35%;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;

      h4 {
        display: block;
        font-weight: 500;
        font-size: 84px;
        color: #0072B9;
        width: max-content;
      }

      span {
        margin-top: 20px;
        display: block;
        font-weight: 500;
        font-size: 48px;
        color: #0072B9;
      }

      textarea {
        text-align: center;
        border: none;
        resize: none;
        outline: none;
        font-weight: 500;
        font-size: 48px;
        color: #0072B9;
        height: 80px;
      }

      .head textarea {
        margin-top: 20px;
      }

      .head + textarea, .head + span {
        margin-top: 120px;
      }
    }

    .cover-foot {
      z-index: 2;
      position: absolute;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0 70px;

      .desc-box {
        margin-top: 120px;
        padding-right: 120px;

        p {
          font-size: 26px;
          line-height: 1.5;
          color: #0072B9;
          white-space: pre-line;
        }

        ul {
          margin-top: 15px;
          display: flex;
          align-items: center;
          gap: 0 5px;

          li {
            flex: 1;
            text-align: center;
            padding: 15px 10px;
            background: linear-gradient(131deg, rgba(121, 180, 220, 1) 0%, rgba(1, 95, 140, 1) 100%);
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
          }
        }
      }
    }
  }
`;
